<template>
  <div class="form-item-select">
    <label class="form-item-select__label" :for="element.metadata?.key">{{ element.metadata?.title }}</label>
    <select :id="element.metadata?.key" :name="element.metadata?.key" class="form-item-select__select">
      <option
        v-for="option in element.options"
        :key="option?.value"
        :value="option?.value"
        :selected="option?.value === defaultValue"
      >
        {{ option?.title }}
      </option>
    </select>
  </div>
</template>
<script setup lang="ts">
import { type WebformElementOptionsBaseFragment, type WebformSubmissionValidationErrorFragment } from '#graphql-operations'

const props = defineProps<{
  element: WebformElementOptionsBaseFragment
  formErrors: WebformSubmissionValidationErrorFragment[]
}>()

const defaultValue = computed(()=> {
 return props.element.metadata?.defaultValue?.replaceAll('"', '')
})
</script>

<style lang="scss">
@use "~/assets/sass/tools";

.form-item-select {
  @include tools.form-group-text;

  &__select {
    @include tools.form-field-select;
  }
}
</style>
